var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"outlined":"","disabled":!_vm.isFiltered,"color":'error',"small":""},on:{"click":function($event){return _vm.clearFilters()}}},[_vm._v(" "+_vm._s(_vm.$t("servicesystem.common_objects.commonterms.clear"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }